exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "agm-map {\n  height: 100%;\n  position: absolute;\n  display: block;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/danfostersmith/Documents/GitHub/crossing-borders/src/app/map/map.component.css
// module id = ../../../../../src/app/map/map.component.css
// module chunks = main